import { AcceleratorDocStoreKey } from "../models/AcceleratorDoc";
import { ModelStoreKey } from "../models/Model";

export { compareAccDocKey, compareModelKey };

const compareAccDocKey = (
  a?: AcceleratorDocStoreKey,
  b?: AcceleratorDocStoreKey,
): boolean => {
  if (!a || !b) {
    // return false if both undefined. should probably error here
    return false;
  }
  return a.batchInstanceUuid === b.batchInstanceUuid && a.docId === b.docId;
};
const compareModelKey = (a?: ModelStoreKey, b?: ModelStoreKey): boolean => {
  if (!a || !b) {
    // return false if both undefined. should probably error here
    return false;
  }
  return (
    a.batchClassIdentifier === b.batchClassIdentifier &&
    a.name === b.name &&
    (a.docType === undefined || b.docType === undefined || a.docType === b.docType)
  );
};
